const config = {
  accountApiUrl: `${process.env.REACT_APP_API_URL}account/`,
  authApiUrl: `${process.env.REACT_APP_API_URL}auth/`,
  commonApiUrl: `${process.env.REACT_APP_API_URL}common/`,
  ocppApiUrl: `${process.env.REACT_APP_API_URL}ocpp-service/`,
  reportApiUrl: `${process.env.REACT_APP_API_URL}reporting/`,
  notificationApiUrl: `${process.env.REACT_APP_API_URL}notification/`,
  transactionApiUrl: `${process.env.REACT_APP_API_URL}transactions/`,
  websocketUrl: process.env.REACT_APP_SOCKET_SERVER_URL || '',
  domain: process.env.REACT_APP_DOMAIN || '',
  appUrl: process.env.REACT_APP_URL,
  qrCodeUrl: process.env.REACT_APP_QR_CODE_URL || '',
};

export default config;
